import get from 'lodash/get';
import { fade, makeStyles } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Briefcase as BriefcaseIcon } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setCompanyEntity } from 'src/store/reducers/entity';
import { isCompanySelected } from 'src/store/selectors/entity';

import CompanySelectorForm from './components/CompanySelectorForm';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  companyIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '20ch',
      '&:focus': {
        width: '28ch',
      },
    },
  },
}));

const ManagerCompanySelector = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation('companies');
  const { enqueueSnackbar } = useSnackbar();
  const managerCompanies = useSelector((state) => state.user.user?.permissions);
  const companyEntity = useSelector(isCompanySelected);

  const referrer = get(location, 'state.referrer');

  const handleChange = (e, value) => {
    dispatch(setCompanyEntity({ company: value }));
    enqueueSnackbar(t('modals.success.company_selected'), { variant: 'success' });

    if (referrer === 'demands') {
      history.push('/app/demands');
    }
  };

  return (
    <div className={classes.search}>
      <div className={classes.companyIcon}>
        <BriefcaseIcon />
      </div>

      <CompanySelectorForm
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}
        companies={managerCompanies || []}
        handleChange={handleChange}
        company={companyEntity}
      />
    </div>
  );
};

export default ManagerCompanySelector;
